import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import MainLayout from "../../../../components/layout/MainLayout";
import Breadcrumbs from "../../../../components/common/Breadcrumbs";
import ComplaintForm from "./ComplaintForm";
import { useDispatch } from "react-redux";
import { createComplaintForm } from "../../../../store/slices/complaintFormSlice";

const AddComplaint = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();
    const { caseId, patientId } = state || {};

    const [formData, setFormData] = useState({
        caseId: state?.caseId || null,
        patientId: state?.patientId || null,

        dateOfComplaint: "",
        department: "",
        otherDepartment: "",
        complaintDescription: "",
        suggestedSolution: "",

        resolutionSummary: "",
        dateOfResolution: "",

        resolvedBy: "",
        staffDateOfResolution: "",

        adminRepresentative: "",
        adminDate: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Convert camelCase → snake_case
        const payload = {
            patient_id: formData.patientId,
            case_id: formData.caseId,

            date_of_complaint: formData.dateOfComplaint,
            department: formData.department,
            other_department: formData.department === "Other" ? formData.otherDepartment : null,
            complaint_description: formData.complaintDescription,
            suggested_solution: formData.suggestedSolution,

            resolution_summary: formData.resolutionSummary,
            date_of_resolution: formData.dateOfResolution,

            resolved_by: formData.resolvedBy,
            staff_date_of_resolution: formData.staffDateOfResolution,

            admin_representative: formData.adminRepresentative,
            admin_date: formData.adminDate,
        };

        try {
            const res = await dispatch(createComplaintForm(payload)).unwrap();

            Swal.fire({
                title: "Saved!",
                text: "Complaint Form completed.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false
            });

            navigate(`/phase03/complaint-form/edit/${res.id || res.data?.id || (res && res[0]?.id)}`, { state: { patientId: patientId || (res && res.patient_id), caseId: caseId || (res && res.case_id) } });
        } catch (error) {
            Swal.fire("Error", "Something went wrong.", "error");
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <ComplaintForm
                                formData={formData}
                                handleChange={handleChange}
                            />

                            <div className="col-12 d-flex justify-content-end mt-3">
                                <div className="col-md-2 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-primary px-4 sticky-form-submit">
                                        <i className="ri-save-2-line me-1"></i>
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default AddComplaint;
